import React, { Component } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  Checkbox,
  Select,
  Tooltip,
  Radio,
  Spin,
} from "antd";
import { SvgIcon, Row, Col } from "../../../components/common";
import "./add-products.scss";

import ProductCard from "./product-card";

// import images

import {
  createLoadingSelector,
  resetStoreState,
  getItemFilters,
  getItemSearchResult,
  saveCollectionItems,
} from "../../../redux/action";
import { serverApis } from "../../../constants/server-apis";
import { connect } from "react-redux";
import { isObjectEmpty, isObjectNotEmpty } from "../../../common/utils";
import { loggedInUserDetail } from "../../../common/methods";
import { showAlert } from "../../../common/alert-messages";
import { baseServerAdress } from "../../../constants/server-address";

const { Option } = Select;

const filterKeys = {
  vendor: "vendors",
  categories: "catalog_item_categories",
};

class AddProductsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.initialRequestObjAndState(),
      visible: false,
    };
  }

  //formRef = React.createRef();

  initialRequestObjAndState = () => {
    return {
      requestObject: {
        is_dynamic_query: false,
        dynamic_query: {
          company_id: isObjectNotEmpty(loggedInUserDetail())
            ? loggedInUserDetail().company_id
            : "",
          price_from: "",
          price_to: "",
          vendors: "",
          catalog_item_categories: "",
          catalog_items: "",
        },
        collection_items: [],
      },
      alreadySelectedItems: [],
      checkedAlreadySelectedItems: [],
      checkedSearchResultItems: [],
      selectedItems: [],
    };
  };

  showModal = () => {
    this.props.getItemFilters(this.props.collectionId);

    this.setState({
      visible: true,
      collectionId: this.props.collectionId,
      ...this.initialRequestObjAndState(),
    });
  };

  handleChange = (value, category) => {
    let requestObject = this.state.requestObject;
    requestObject.dynamic_query[category] = value.join();
    this.setState({ requestObject });
  };

  handleOk = () => {
    // this.setState({ visible: false });
    this.resetAndClosePopup();
  };

  handleCancel = () => {
    this.resetAndClosePopup();
  };
  componentDidUpdate() {
    if (isObjectNotEmpty(this.props.itemSelectedItems)) {
      let selectedItems = [];
      for (
        let index = 0;
        index < this.props.itemSelectedItems.length;
        index++
      ) {
        const item = this.props.itemSelectedItems[index];
        selectedItems.push({
          ...item,
          item_id: item.id,
          company_id: loggedInUserDetail().company_id,
          isChecked: true,
        });
      }

      this.setState({
        checkedAlreadySelectedItems: selectedItems,
        alreadySelectedItems: [...this.props.itemSelectedItems],
        selectedItems: [...selectedItems],
      });
      this.props.resetStoreState(serverApis.getCollectionItems.actionName);
    }
    if (this.state.visible) {
      if (isObjectNotEmpty(this.props.saveCollectionItemsSuccessMessage)) {
        showAlert.success(this.props.saveCollectionItemsSuccessMessage);
        this.props.resetStoreState(serverApis.saveCollectionItems.actionName);
        this.resetAndClosePopup();
      }

      if (isObjectNotEmpty(this.props.itemsDynamicQuery)) {
        let query = this.props.itemsDynamicQuery;
        let requestObject = this.state.requestObject;
        requestObject.is_dynamic_query = true;
        requestObject.dynamic_query = query;

        this.setState({ requestObject });

        this.props.resetStoreState(serverApis.getCollectionItems.actionName);

        this.handleSearch();
      }
    }
  }
  onChange = (e) => {
    let requestObject = this.state.requestObject;
    let checkedAlreadySelectedItems = this.state.checkedAlreadySelectedItems;
    if (!requestObject.is_dynamic_query) {
      requestObject.collection_items = [];
      checkedAlreadySelectedItems = [];
    } else {
      let selectedItems = [];
      for (
        let index = 0;
        index < this.state.alreadySelectedItems.length;
        index++
      ) {
        const item = this.state.alreadySelectedItems[index];
        selectedItems.push({
          item_id: item.id,
          company_id: loggedInUserDetail().company_id,
        });
      }
      checkedAlreadySelectedItems = selectedItems;
    }
    requestObject.is_dynamic_query = !requestObject.is_dynamic_query;

    this.setState({
      requestObject,
      checkedAlreadySelectedItems,
    });
  };

  handleInputChange = (e) => {
    let requestObject = this.state.requestObject;
    requestObject.dynamic_query[e.target.id] = e.target.value;
    this.setState({ requestObject });
  };
  handleSearch = () => {
    let requestObject = this.state.requestObject;
    if (this.isZeroFiltersSelected()) {
      return;
    }

    this.props.resetStoreState(serverApis.getItemSearchResult.actionName);

    // requestObject.collection_items = [];
    this.setState({ requestObject });
    this.props.getItemSearchResult(requestObject.dynamic_query);
  };

  onSelectAllSelectedItems = (checked) => {
    let requestObject = this.state.requestObject;
    let selectedItems = this.state.selectedItems;

    for (let index = 0; index < selectedItems.length; index++) {
      const item = selectedItems[index];
      item.isChecked = checked;
    }
    requestObject.is_dynamic_query = false;

    this.setState({
      requestObject,
      selectedItems: [...selectedItems],
    });
  };
  onSelectAllItemForSearchResults = () => {
    let requestObject = this.state.requestObject;
    let selectedItems = this.state.selectedItems;
    for (let index = 0; index < this.props.itemSearchResult.length; index++) {
      const item = this.props.itemSearchResult[index];
      if (
        isObjectEmpty(
          this.state.selectedItems.find(
            (existingItem) => existingItem.id === item.id
          )
        )
      ) {
        selectedItems.push({
          ...item,
          isChecked: true,
          id: item.id,
          item_id: item.id,
        });
      }
    }
    requestObject.is_dynamic_query = false;
    this.setState({
      requestObject,
      selectedItems: [...selectedItems],
    });
  };

  resetAndClosePopup = () => {
    this.setState({
      visible: false,
      ...this.initialRequestObjAndState(),
    });
    this.props.resetStoreState(serverApis.getItemFilters.actionName);
    this.props.resetStoreState(serverApis.getCollectionItems.actionName);
    this.props.resetStoreState(serverApis.getItemSearchResult.actionName);
  };

  onAddOrSelectItem = (checked, selectedItem, addNewItem) => {
    let requestObject = this.state.requestObject;
    let selectedItems = this.state.selectedItems;
    if (addNewItem) {
      if (
        isObjectEmpty(
          this.state.selectedItems.find((item) => item.id === selectedItem.id)
        )
      ) {
        selectedItems.push({
          ...selectedItem,
          isChecked: true,
          id: selectedItem.id,
          item_id: selectedItem.id,
        });
      } else {
        showAlert.error("Item Already exists in selected items!");
      }
    } else {

      selectedItems.map((item) => {
        if (item.id === selectedItem.id) {
          item.isChecked = checked;
        }
        return 0;
      });
    }
    requestObject.is_dynamic_query = false;

    this.setState({
      requestObject,
      selectedItems: [...selectedItems],
    });
  };

  isZeroFiltersSelected = () => {
    let requestObject = this.state.requestObject;

    if (
      isObjectEmpty(requestObject.dynamic_query.price_from) &&
      isObjectEmpty(requestObject.dynamic_query.price_to) &&
      isObjectEmpty(requestObject.dynamic_query.vendors) &&
      isObjectEmpty(requestObject.dynamic_query.catalog_item_categories) &&
      isObjectEmpty(requestObject.dynamic_query.catalog_items)
    ) {
      showAlert.error("Please select at least one filter option.");

      return true;
    } else {
      return false;
    }
  };

  saveCollectionItems = () => {
    if (this.state.requestObject.is_dynamic_query) {
      if (this.isZeroFiltersSelected()) {
        return;
      }
    }

    let requestObject = {
      ...this.state.requestObject,
      collection_items: this.state.selectedItems
        .filter((selectedItem) => selectedItem.isChecked)
        .map((item) => {
          return {
            ...item,
            item_id: item.id,
            company_id: loggedInUserDetail().company_id,
          };
        }),
    };

    this.props.saveCollectionItems(requestObject, this.props.collectionId);
  };

  render() {
    if (this.state.visible) {
    }
    const { visible } = this.state;
    if (this.state.visible) {
    }
    return (
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Tooltip
          overlayClassName="tooltip-cards"
          placement="bottomLeft"
          title="Manage Item"
        >
          <div
            onClick={this.showModal}
            key="add-item"
            className="cursor-pointer"
          >
            <SvgIcon width="20" name="item" viewbox="0 0 22.569 19.009" />
          </div>
        </Tooltip>
        <Modal
          visible={visible}
          title="Add Products"
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          closeIcon={<SvgIcon name="close" viewbox="0 0 298.667 298.667" />}
          className="modal-cms add-product-modal"
          footer={false}
          width={1100}
        >
          {" "}
          <Spin spinning={this.props.isFetchingData} size="large">
            <div className="add-product-main">
              <Row>
                <Col sm="4" className="product-search">
                  <Form
                    initialValues={{ remember: false }}
                    onFinish={this.handleSearch}
                    layout="vertical"
                    // ref={this.formRef}
                  >
                    <Row className="mb-2">
                      <Col sm="12">
                        <Form.Item
                          className="mb-3"
                          id="catalog_item_categories"
                        >
                          <label htmlFor="product_category">
                            Product Category
                          </label>
                          <Select
                            mode="multiple"
                            placeholder="All Categories"
                            showArrow
                            allowClear
                            id="catalog_item_categories"
                            size="large"
                            onChange={(value) =>
                              this.handleChange(value, filterKeys.categories)
                            }
                            value={
                              isObjectEmpty(
                                this.state.requestObject.dynamic_query
                                  .catalog_item_categories
                              )
                                ? []
                                : this.state.requestObject.dynamic_query.catalog_item_categories.split(
                                    ","
                                  )
                            }
                            filterOption={(input, option) => {
                              return (
                                option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0 ||
                                option.props.value
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              );
                            }}
                          >
                            {this.props.productFilters.categories.map(
                              (category, i) => (
                                <Option
                                  key={category.id}
                                  value={`${category.id}`}
                                >
                                  {category.code}
                                </Option>
                              )
                            )}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col sm="6">
                        <Form.Item className="mb-3">
                          <label htmlFor="itemprice">Item Price</label>
                          <Input
                            id="price_from"
                            size="large"
                            placeholder="From"
                            value={
                              this.state.requestObject.dynamic_query.price_from
                            }
                            onChange={(value) => this.handleInputChange(value)}
                          />
                        </Form.Item>
                      </Col>
                      <Col sm="6">
                        <label htmlFor="">&nbsp; </label>
                        <Form.Item className="mb-3">
                          <Input
                            id="price_to"
                            size="large"
                            placeholder="To"
                            value={
                              this.state.requestObject.dynamic_query.price_to
                            }
                            onChange={(value) => this.handleInputChange(value)}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col sm="12">
                        <Form.Item className="mb-3">
                          <label htmlFor="vendors">Parent Vendor</label>
                          <Select
                            mode="multiple"
                            placeholder="All Vendors"
                            showArrow
                            allowClear
                            id="vendors"
                            size="large"
                            onChange={(value) =>
                              this.handleChange(value, filterKeys.vendor)
                            }
                            value={
                              isObjectEmpty(
                                this.state.requestObject.dynamic_query.vendors
                              )
                                ? []
                                : this.state.requestObject.dynamic_query.vendors.split(
                                    ","
                                  )
                            }
                            filterOption={(input, option) => {
                              return (
                                option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0 ||
                                option.props.value
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              );
                            }}
                          >
                            {this.props.productFilters.vendors.map(
                              (vendor, i) => (
                                <Option key={i} value={`${vendor.id}`}>
                                  {vendor.name}
                                </Option>
                              )
                            )}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col sm="12">
                        <Form.Item className="mb-3">
                          <label htmlFor="catalog_items">Item #</label>
                          <Input
                            id="catalog_items"
                            size="large"
                            placeholder=""
                            onChange={(value) => this.handleInputChange(value)}
                            value={
                              this.state.requestObject.dynamic_query
                                .catalog_items
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="12">
                        <Button htmlType="submit" type="primary" block>
                          Search
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Col>
                <Col sm="8" className="product-right-main">
                  <div className="product-right-inner">
                    {/* <div className="no-products">
                                        <div>
                                            <h1>Products will be shown here</h1>
                                        </div>
                                    </div> */}
                    <Row>
                      <Col sm="12">
                        <Row>
                          <Col sm="12">
                            <Radio.Group
                              onChange={this.onChange}
                              value={this.state.requestObject.is_dynamic_query}
                            >
                              <Radio value={true}>
                                Save dynamic query to fetch products for this
                                collection
                              </Radio>
                              <div className="my-2">OR</div>
                              <Radio className="mr-0" value={false}>
                                Select manually
                              </Radio>
                              {/* {
                                this.state.selectedItems.length >
                              0
                                ? `(${
                                  
                                    this.state.selectedItems
                                      .length
                                  } item${
                                   
                                      this.state.selectedItems
                                        .length ===
                                    1
                                      ? ""
                                      : "s"
                                  } selected)`
                                : ""} */}
                            </Radio.Group>
                          </Col>
                        </Row>

                        {isObjectNotEmpty(this.state.selectedItems) && (
                          <Row>
                            <Col sm="12">
                              <Checkbox
                                className="mt-n3"
                                style={{ float: "right" }}
                                onChange={(e) =>
                                  this.onSelectAllSelectedItems(
                                    e.target.checked
                                  )
                                }
                                checked={
                                  !this.state.requestObject.is_dynamic_query &&
                                  isObjectNotEmpty(this.state.selectedItems) &&
                                  this.state.selectedItems.every(
                                    (item) => item.isChecked
                                  )
                                }
                              >
                                Select All Items
                              </Checkbox>
                            </Col>
                          </Row>
                        )}

                        <Row className="product-lists mt-3">
                          {isObjectNotEmpty(this.state.selectedItems) && (
                            <Col sm="12">
                              <h3>Selected Items</h3>
                            </Col>
                          )}

                          {this.state.selectedItems.map((item, i) => {
                            return (
                              <ProductCard
                                key={i}
                                isChecked={item.isChecked}
                                onSelectItem={this.onAddOrSelectItem}
                                prdoductImg={
                                  baseServerAdress.ITEM_IMAGE +
                                  item.image_thumnail
                                }
                                prdoductName={item.name}
                                productCode={item.web_code}
                                id={item.web_code}
                                productKey={item.id}
                                product={item}
                              />
                            );
                          })}
                        </Row>

                        <div className="addproduct-searchrow">
                          <Row className="align-items-center">
                            <Col sm="6">
                              <h3 className="mb-0">Search Results</h3>
                            </Col>{" "}
                            {
                              isObjectNotEmpty(this.props.itemSearchResult) 
                              &&  (  
                              <Col sm="6" className="text-right">
                                <Button
                                  size="small"
                                  className="btn-success radius productcard-addbtn"
                                  onClick={() =>
                                    this.onSelectAllItemForSearchResults()
                                  }
                                >
                                  Add All Items
                                </Button>
                              </Col>) 
                            
                            }
                           
                          </Row>
                        </div>

                        <Row className="product-lists mt-3">
                          {this.props.itemSearchResult.map((item, i) => {
                            return (
                              <ProductCard
                                key={i}
                                // isChecked={
                                //   this.state.requestObject.collection_items.filter(
                                //     (element) => element.item_id === item.id
                                //   ).length !== 0
                                // }
                                onSelectItem={this.onAddOrSelectItem}
                                prdoductImg={
                                  baseServerAdress.ITEM_IMAGE +
                                  item.image_thumnail
                                }
                                prdoductName={item.name}
                                productCode={item.web_code}
                                id={item.web_code}
                                productKey={item.id}
                                hideButton={true}
                                product={item}
                              />
                            );
                          })}
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  <div className="product-right-action text-right">
                    <Button className="btn-md" onClick={this.handleCancel}>
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      size="large"
                      className="px-5 ml-3 btn-md"
                      onClick={this.saveCollectionItems}
                    >
                      Save
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Spin>
        </Modal>
      </div>
    );
  }
}

const loadingSelector = createLoadingSelector([
  serverApis.getItemFilters.actionName,
  serverApis.getCollectionItems.actionName,
  serverApis.getItemSearchResult.actionName,
  serverApis.saveCollectionItems.actionName,
]);

const mapStateToProps = (state) => ({
  isFetchingData: loadingSelector(state),
  productFilters: state.productFilters,
  itemSearchResult: state.itemSearchResult,
  itemSelectedItems: state.itemSelectedItems,
  itemsDynamicQuery: state.itemsDynamicQuery,
  saveCollectionItemsSuccessMessage: state.saveCollectionItemsSuccessMessage,
});

export default connect(mapStateToProps, {
  getItemFilters,
  getItemSearchResult,
  resetStoreState,
  saveCollectionItems,
})(AddProductsModal);
